import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "loading"]

  connect() {
    this.element.addEventListener("turbo:submit-start", () => this.showLoading())
    this.element.addEventListener("turbo:submit-end", () => this.hideLoading())
  }

  showLoading() {
    this.contentTarget.classList.add("hidden")
    this.loadingTarget.classList.remove("hidden")
  }

  hideLoading() {
    this.contentTarget.classList.remove("hidden")
    this.loadingTarget.classList.add("hidden")
  }
}
